import {
    Box,
    Grid,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import ButtonContained from "../../Common/ButtonContained";
import CustomDialog from "../../Common/CustomDialog";
import TextLabel from "../../Common/CommonTextLabel";
import { showLoader } from "../../../Redux/Slices/loaderSlice";
import { useDispatch } from "react-redux";
import {
    createpressandmediacoverage,
    getallpressandmediacoverage,
    getPrivacyPolicyAndTermsAndCondition,
    updatepressandmediacoverage,
} from "../../../Redux/Actions/action";
import ErrorHandler from "../../../Utils/handler";
import { toast } from "react-toastify";
import CommonTextEditor from "../../Common/CommonTextEditor";

function PressAndMediaCoverage() {
    // ---------- Hook -----------
    const dispatch = useDispatch();

    // --------------- State -------------
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({});
    const [privacyPolicyData, setPrivacyPolicyData] = useState({});

    const [error, setError] = useState({});
    const [isEdit, setIsEdit] = useState(false);

    const handleClear = () => {
        setOpen(false);
        setIsEdit(false);
        setData({});
        setError({});
    };

    const validation = () => {
        let isValid = true;
        let error = {};
        if (!data.description) {
            error.description = "Description is required";
            isValid = false;
        }
        setError(error);
        return isValid;
    };

    const _createPrivacyPolicyAndTermsAndCondition = async () => {
        if (validation()) {
            dispatch(showLoader(true));
            try {
                let body = {
                    "type": "Terms-Conditions",
                    description: data?.description,
                }; 
                if (isEdit && data?._id) {
                    body.id = data?._id;
                }
                const fn = isEdit ? updatepressandmediacoverage : createpressandmediacoverage
                const result = await dispatch(fn(body));
                const error = ErrorHandler(result);
                if (error) {
                    toast.success(result?.payload?.message);
                    _getallpressandmediacoverage();
                    handleClear();
                }
            } catch (error) {
                toast.error(error?.message || "An unknown error occurred");
            } finally {
                dispatch(showLoader(false));
            }
        }
    };

    const _getallpressandmediacoverage = async () => {
        dispatch(showLoader(true));
        try {
            const result = await dispatch(getallpressandmediacoverage());
            const error = ErrorHandler(result);
            if (error) {
                setPrivacyPolicyData(result?.payload?.data?.response?.[0]);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    useEffect(() => {
        _getallpressandmediacoverage();
    }, []);

    return (
        <>
            <Grid container spacing={1} xs={12}>
                <Grid item xs={12}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: 500 }}>
                            Press & Media Coverage
                        </Typography>
                        <ButtonContained
                            text={
                                privacyPolicyData?.description
                                    ? "Update Press & Media Coverage"
                                    : "Add Press & Media Coverage"
                            }
                            onClick={
                                privacyPolicyData?.description
                                    ? () => {
                                        setOpen(true);
                                        setIsEdit(true);
                                        setData({
                                            _id: privacyPolicyData?._id,
                                            description:
                                                privacyPolicyData?.description,
                                        });
                                    }
                                    : () => {
                                        setOpen(true);
                                    }
                            }
                        />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <div dangerouslySetInnerHTML={{ __html: privacyPolicyData?.description }} />
                </Grid>
                {open && (
                    <CustomDialog
                        isOpen={open}
                        handleClose={handleClear}
                        title={isEdit ? "Update Press & Media Coverage" : "Add Press & Media Coverage"}
                        padding={"10px"}
                        maxWidth={"md"}
                        action={
                            <>
                                <ButtonContained
                                    text={isEdit ? "Update Press & Media Coverage" : "Add Press & Media Coverage"}
                                    onClick={_createPrivacyPolicyAndTermsAndCondition}
                                    minWidth={"100%"}
                                    marginTop={"10px"}
                                />
                            </>
                        }
                    >
                        <Grid container spacing={2} xs={12} ml={-1}>
                            <Grid item xs={12}>
                                <CommonTextEditor
                                    value={data.description}
                                    onChange={(value) => {
                                        setData({ ...data, description: value });
                                    }}
                                    text={'Description'}
                                    valid={true}
                                />
                                <TextLabel
                                    title={!data?.description ? error?.description : ""}
                                    color="error"
                                />
                            </Grid>
                        </Grid>
                    </CustomDialog>
                )}
            </Grid>
        </>
    );
}

export default PressAndMediaCoverage;
